export function money(v, currency = "R") {
  const n = Number(v || 0);
  return `${currency} ${n.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-ZA", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export function dateInput(d) {
  if (!d) return "";
  try {
    return new Date(d).toISOString().slice(0, 10);
  } catch {
    return "";
  }
}

// Live totals matching backend compute_totals
export function computeTotals(lineItems, discount, discountType) {
  let subtotal = 0;
  const items = lineItems.map((it) => {
    const line = Number(it.quantity || 0) * Number(it.unit_price || 0);
    subtotal += line;
    return { ...it, line_total: line };
  });
  const discountAmount =
    discountType === "percent" ? subtotal * (Number(discount || 0) / 100) : Math.min(Number(discount || 0), subtotal);
  const factor = subtotal > 0 ? (subtotal - discountAmount) / subtotal : 1;
  let vat = 0;
  items.forEach((it) => {
    vat += it.line_total * factor * (Number(it.vat_rate || 0) / 100);
  });
  const total = subtotal - discountAmount + vat;
  return {
    subtotal: round(subtotal),
    discount_amount: round(discountAmount),
    vat_amount: round(vat),
    total: round(total),
  };
}

function round(n) {
  return Math.round(n * 100) / 100;
}
